import React from 'react';
import apiService from '../apiService';

// Liste des villes chargée une seule fois pour toutes les pages qui filtrent par ville.
// /admin/my-cities : lisible par tout admin, limitée à ses villes (/admin/cities = superadmin seul).
let citiesPromise = null;
const loadCities = () => {
  if (!citiesPromise) {
    citiesPromise = apiService.get('/admin/my-cities', { userType: 'admin' })
      .then(res => (res && res.success ? res.cities || [] : []))
      .catch(() => { citiesPromise = null; return []; });
  }
  return citiesPromise;
};

// Nom affichable d'une ville à partir de son slug (repli : slug capitalisé).
export const cityLabel = (cities, slug) => {
  if (!slug) return '—';
  const c = cities.find(x => x.slug === slug);
  return c ? c.name : slug.charAt(0).toUpperCase() + slug.slice(1);
};

export function useCities() {
  const [cities, setCities] = React.useState([]);
  React.useEffect(() => {
    let alive = true;
    loadCities().then(list => { if (alive) setCities(list); });
    return () => { alive = false; };
  }, []);
  return cities;
}

// Sélecteur « Toutes les villes » / ville. value = '' (toutes) ou un city_slug.
export default function CityFilter({ value, onChange, cities: citiesProp, className = 'filter-select', style }) {
  const loaded = useCities();
  const cities = citiesProp || loaded;
  return (
    <select className={className} style={style} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">Toutes les villes</option>
      {cities.map(c => <option key={c.slug} value={c.slug}>{c.name}</option>)}
    </select>
  );
}
